import React from "react";
import "../styles/Experience.css";

const Experience = () => {
  return (
    <div className="education-container" data-aos="zoom-in">
      <main className="row">
        <section className="col">
          <header>
            <h2 className="title">Experience</h2>
          </header>

          <div className="contents">


          <div className="exp-box">
              
              <div className="exp-heading">
              
              <h3>Role: Full Stack Developer at Infinity Technology (6 months)</h3>
              <h4>August 24 - Present</h4>
              </div>
           
              <ul>
              <li><strong>Position:</strong> Full-Stack Developer</li>
              <li><strong>Work Setup:</strong> Remote (Work From Home)</li>
              <li>Salary Structure: Based on individual projects completed</li>
              

              <li>Utilized technologies such as<strong> HTML, CSS, JavaScript, React, Redux, NodeJS, ExpressJS, MongoDB and various backend frameworks.</strong></li>
              <li>Keeps updated with industry trends, new tools, and emerging technologies to enhance personal expertise and bring innovative approaches to each project.</li>
              

              <li>Coordinates with team members and stakeholders to gather project requirements, align development goals, and ensure alignment with project timelines.</li>
              
             


                
              </ul>
            </div>

            <div className="exp-box">
              
              <div className="exp-heading">
              
              <h3>Role: Full Stack Developer at NullClass (6 months)</h3>
              <h4>December 23 - June 24</h4>
              </div>
           
              <ul>
              <li><strong>Position:</strong> Full-Stack Developer</li>
              <li><strong>Work Setup:</strong> Remote (Work From Home)</li>
              <li>Utilized technologies such as<strong> HTML, CSS, JavaScript, React, Redux, NodeJS, ExpressJS, MongoDB and various backend frameworks.</strong></li>
              <li>Worked extensively on user interface design, front-end implementation, and back-end integration.</li>
              <li>Developed strong remote work capabilities, including effective communication and time management.</li>

              <li>Used collaboration tools like Slack, Trello, and Zoom to stay connected with team members and manage project tasks.</li>
              <li>Demonstrated the ability to work independently and as part of a distributed team, delivering results despite geographical distances.</li>
             


                
              </ul>
            </div>

            <div className="exp-box">
            
            <div className="exp-heading">
              
              <h3>Web Developer at Toppersworld (1 month)</h3>
              <h4>February 24 - March 24</h4>
              </div>
              <ul>
              <li><strong>Position:</strong> Web Developer</li>
              <li><strong>Work Setup:</strong> Remote (Work From Home)</li>
              <li>Recognized for delivering <strong>high-quality work, meeting project deadlines, and showing a strong understanding of web development principles.</strong></li>
              <li>Secured a position among the top 5 interns out of a competitive group, demonstrating exceptional performance and dedication.</li>
              <li>Successfully contributed to multiple web development projects, focusing on both front-end and back-end tasks.</li>

              <li>Gained hands-on experience in debugging, code optimization, and ensuring cross-browser compatibility.</li>
              <li>Enhanced collaborative skills and contributed innovative ideas to improve project outcomes.</li>
              </ul>
            </div>

           
          </div>
        </section>
      </main>
    </div>
  );
};

export default Experience;